import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css'; // Import Tailwind CSS


createApp(App).mount('#app')
